import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const groupApi = {
    useAdminCreateGroup : () => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.post(`/admin/groups`, args);
            }
        });
    },
    useAdminGetGroup : (args) => {
        return useQuery({
            query: ['admin', 'group', 'edit', args],
            queryFn: () => {
                return generalRequest.get(`/admin/groups/${args.id}`);
            },
        })
    },
    useAdminUpdateGroup : (args) => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.put(`/admin/groups/${args.id}`, args);
            }
        })
    }

}

export const useApiSearchAdminGroups = (config) => {
    return useQuery({
        queryKey: ['admin', 'group', 'get', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/groups`, config)
        })({params: config})),
    })
}


